import { isClientOptingReact } from 'owa-optin';
import { isFeatureEnabled } from 'owa-feature-flags';
import { migratePersistedAddins } from 'owa-mail-addins';

export default function checkAndUpdatePersistedAddins() {
    if (isClientOptingReact() && isFeatureEnabled('addin-persistentTaskPane')) {
        migratePersistedAddins();
    }
}
